<template>
  <b-card>
      <b-col
          class="table-size"
      >
        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                class="font-weight-bold"
                disabled
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(LastActive)="data">
            {{ data.value | dateToTime }} {{ data.value | date }}
          </template>

          <template #cell(ProductFlavor)="data">
            <b-badge
                :variant="'light-'+enums('ProductFlavor', 'value', data.value, 'badge')"
            >
              {{ enums('ProductFlavor', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <feather-icon
                  icon="CopyIcon"
                  size="16"
                  class="cursor-pointer"
                  @click="$copyText(data.item.Token)"
              />
            </div>
          </template>

        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />

      </b-col>
  </b-card>
</template>

<script>

export default {
  name: 'UserToken',
  props: {
    userId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        UserId: this.userId,
        Page: 1,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'LastActive',
          label: 'آخرین فعالیت',
        },
        {
          key: 'ProductFlavor',
          label: 'مارکت',
        },
        {
          key: 'BuildNumber',
          label: 'ورژن',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-10',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.usertoken.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
  },
}
</script>
